site.toolsToogle = {
	init: function () {
		const SELECTOR = '.virkCard--overlay button.heart';
		const CLOSEBUTTONSELECTOR = '.virkCard--overlay button.heart + .heart-message .close-heart-message';
		const elements = document.querySelectorAll(SELECTOR);
		const closeButtonElement = document.querySelectorAll(CLOSEBUTTONSELECTOR);

		if (!elements) {
			return;
		}

		elements.forEach(item => {
			item.addEventListener('click', (e) => {
				let xhr = new XMLHttpRequest();
				xhr.open('POST', '/_/moya/virk-back-to-work/index/submitTool');
				xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
				item.classList.toggle('selected');
				$('#btw__toolbox .virkCard .heart' + '[data-id='+ item.getAttribute('data-id') + ']').toggleClass('selected');
				$('#btw__results .virkCard .heart' + '[data-id='+ item.getAttribute('data-id') + ']').toggleClass('selected');
				$('.heart' + '[data-id='+ item.getAttribute('data-id') + '] + .heart-message').toggleClass('selected');
				let value = Number(item.classList.contains('selected'));
				xhr.send(encodeURI('toolId=' + item.getAttribute('data-id') + '&value=' + value));

				const heartMessageElement = $('.virkCard--overlay button.heart + .heart-message');

				if (heartMessageElement.hasClass('selected')) {
					heartMessageElement.toggleClass('show');
				}

				document.body.classList.remove('btw-no-cookie-id');
			});
		});

		closeButtonElement.forEach(el => {
			el.addEventListener('click', ev => {
				el.closest('.heart-message').classList.remove('show');
			});
		});

	},
	initCards: function() {
		const CARDBUTTONSELECTOR = '#btw__toolbox .virkCard .heart';
		const SELECTORHEARTMESSAGE = '.heart-message';
		const CLOSEBUTTONSSELECTOR = '.heart-message div.close-heart-message';
		const cardButtonElements = document.querySelectorAll(CARDBUTTONSELECTOR);
		const closeButtons = document.querySelectorAll(CLOSEBUTTONSSELECTOR);


		cardButtonElements.forEach(item => {
			item.addEventListener('click', e => {
				let xhr = new XMLHttpRequest();
				xhr.open('POST', '/_/moya/virk-back-to-work/index/submitTool');
				xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
				item.classList.toggle('selected');
				$('.virkCard--overlay .heart[data-id="' + item.getAttribute('data-id') + '"]').toggleClass('selected');
				$('.virkCard--overlay .heart[data-id="' + item.getAttribute('data-id') + '"] + .heart-message').toggleClass('selected');
				let value = Number(item.classList.contains('selected'));
				xhr.send(encodeURI('toolId=' + item.getAttribute('data-id') + '&value=' + value));

				const heartMessageElement = document.querySelector('.heart[data-id="' + item.getAttribute('data-id') + '"] + .heart-message');

				heartMessageElement.classList.contains('selected')
					? heartMessageElement.classList.remove('selected')
					: heartMessageElement.classList.add('selected');

				heartMessageElement.classList.contains('selected')
					? heartMessageElement.classList.add('show')
					: heartMessageElement.classList.remove('show');

				document.body.classList.remove('btw-no-cookie-id');
			});
		});

		closeButtons.forEach(item => {
			item.addEventListener('click', e => {
				const heartMessageElement = e.target.closest('.heart-message');
				heartMessageElement.classList.remove('show');
			});
		});

		window.addEventListener('click', (event) => {
			const clickedMessageContainer = event.target.closest(SELECTORHEARTMESSAGE);
			const clickedHeartButton = event.target.closest(CARDBUTTONSELECTOR);
			const clickedHeartButtonOverlay = event.target.closest('.virkCard--overlay button.heart');
			const clickedMessageContainerOverlay = event.target.closest('.virkCard--overlay button.heart + .heart-message');
			const messageContainers = document.querySelectorAll(SELECTORHEARTMESSAGE);
			if (!clickedMessageContainer && !clickedHeartButton && !clickedMessageContainerOverlay && !clickedHeartButtonOverlay) {
				messageContainers.forEach(container => container.classList.remove('show'))
			}
		});
	}
};

site.examAnswerWrap = {
	init: function () {
		$('.btw__results .exam__wrap .answers').each(function() {
			$(this).contents().filter(function() {
				return this.nodeType == 3;
			}).wrap('<span style="color:#FFFFFF!important"></span>');
		});
		$('.btw__results .exam__wrap .answers span').each(function() {
			var $this = $(this);
			if($this.html().replace(/\s|&nbsp;/g, '').length == 0)
				$this.remove();
		});
	}
};

site.results = {
	pdf: function() {
		window.jsPDF = window.jspdf.jsPDF;
		window.printPDF = async () => {
			let offset = 0;

			var top_left_margin = 15;
			/*const a4Width = 595;
			const a4Height = 842;*/
			const a4Width = 842;
			const a4Height = 595;
			const a4WidthNoMargins = a4Width - 2 * top_left_margin;
			const a4HeightNoMargins = a4Height - top_left_margin;
			const element = $('.btw__results__wrap');
			if (element.length === 0) {
				window.alert('Eitthvað fór úrskeiðis');
				return;
			}

			const canvas = await html2canvas(element[0], {
				allowTaint: false,
				onclone: (document) => {
					document.querySelector('h2').style.fontSize = '40px';
					const resultBoxes = document.querySelectorAll('.exams > .exam');

					if (resultBoxes.length < 5) {
						resultBoxes.forEach(el => {
							el.style.width = '50%';
						});
					}
				},
			});

			var pdf = new jsPDF('l', 'pt', [a4Width, a4Height]);
			const heightWidthRatio = canvas.height / canvas.width;
			const nrOfPages = Math.ceil((heightWidthRatio * a4WidthNoMargins) / (a4HeightNoMargins));

			let imgData = canvas.toDataURL("image/jpeg", 1.0);
			pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin, a4WidthNoMargins, a4WidthNoMargins * heightWidthRatio);

			for (let i = 1; i < nrOfPages; i++) {
				pdf.addPage([a4Width, a4Height]);
				pdf.addImage(imgData, 'JPG', top_left_margin, -(a4HeightNoMargins * i + top_left_margin * i), a4WidthNoMargins, a4WidthNoMargins * heightWidthRatio);
			}

			pdf.save('results.pdf');

		}
	}
}

site.inits.push('site.examAnswerWrap.init()');
site.inits.push('site.toolsToogle.initCards()');
